/**
 * API client for the role-based home system.
 * Endpoints:
 *   GET  /api/me/home-config      →  { role, catalog, config: { layout, hidden } }
 *   PUT  /api/me/home-config      →  save layout + hidden
 *   POST /api/me/home-config/reset
 *   GET  /api/me/team-overview    →  aggregated team stats
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const unwrap = (p) => p.then(r => r.data).catch(err => {
  const msg = err?.response?.data?.detail || err.message;
  throw new Error(msg);
});

export const RoleHomeAPI = {
  getConfig: () => unwrap(axios.get(`${API}/me/home-config`, { withCredentials: true })),
  saveConfig: (layout, hidden) =>
    unwrap(axios.put(`${API}/me/home-config`, { layout, hidden }, { withCredentials: true })),
  reset: () => unwrap(axios.post(`${API}/me/home-config/reset`, {}, { withCredentials: true })),
  teamOverview: () => unwrap(axios.get(`${API}/me/team-overview`, { withCredentials: true })),
  createShare: (name, layout) => unwrap(axios.post(`${API}/shared-home/create`, { name, ...(layout ? { layout } : {}) }, { withCredentials: true })),
  listShares: () => unwrap(axios.get(`${API}/shared-home/mine`, { withCredentials: true })),
  revokeShare: (shareId) => unwrap(axios.delete(`${API}/shared-home/${shareId}`, { withCredentials: true })),
  getPublicShare: (token) => unwrap(axios.get(`${API}/public/shared-home/${token}`)),
  getPublicShareData: (token) => unwrap(axios.get(`${API}/public/shared-home/${token}/data`)),
};
